﻿
export function initCollapses() {
	const collapseElements = document.querySelectorAll('[data-collapse]');

	collapseElements.forEach((element, index, parent) => {
		let options = JSON.parse(element.dataset.collapse);
		element.addEventListener(options.event, toggleCollapse);
	});
}

document.addEventListener('DOMContentLoaded', function (event) {
	initCollapses();
});

function toggleCollapse(event) {
	const options = JSON.parse(event.currentTarget.dataset.collapse);
	const collapseTarget = document.querySelector(options.targetId);
	resetForParent(collapseTarget, options);

	collapseTarget.classList.toggle(options.class);

	if (options.addToTrigger) {
		event.currentTarget.classList.toggle(options.class);
	}
}

function resetForParent(collapseTarget, options) {
	let parent = document.querySelector(options.parentId);
	if (parent !== null) {
		let elements = parent.querySelectorAll('[data-collapse]');
		elements.forEach((element, index, parent) => {
			const options = JSON.parse(element.dataset.collapse);
			const elementTarget = document.querySelector(options.targetId);
			if (elementTarget && !elementTarget.isEqualNode(collapseTarget)) {
				switch (options.func) {
					case 'add':
						elementTarget.classList.add(options.class);
						if (options.addToTrigger) {
							element.classList.add(options.class);
						}
						break;
					case 'remove':
						elementTarget.classList.remove(options.class);
						if (options.addToTrigger) {
							element.classList.remove(options.class);
						}
						break;
					case 'toggle':
						elementTarget.classList.toggle(options.class);
						if (options.addToTrigger) {
							element.classList.toggle(options.class);
						}
						break;
				}

			}
		});
	}
}

